<template>
    <!-- Repeatable Field aka. an array of fields --->
    <v-card class="mb-6">
        <v-card-title>{{ props.label }}</v-card-title>
        <v-card-subtitle v-if="props.hint && props.hint !== props.label">{{ props.hint }}</v-card-subtitle>
        <v-card-text>
            <draggable :list="value"
                       :item-key="((item) => value.indexOf(item))"
                       handle=".drag-handle">
                <template #item="{element, index}">
                    <v-row dense>
                        <v-col>
                            <v-text-field v-model="value[index].amount" :label="$t('editor.fields.ingredient.amount')">
                                <template v-slot:prepend>
                                    <v-icon class="drag-handle">mdi-drag-vertical</v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field v-model="value[index].name" :label="$t('common.fields.name')"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field v-model="value[index].link" :label="$t('editor.fields.ingredient.link')">
                                <template v-slot:append>
                                    <v-icon @click="removeFromList(element)" :title="$t('common.actions.remove')">mdi-close</v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </template>
            </draggable>
        </v-card-text>
        <v-card-actions>
            <v-btn icon="mdi-plus-circle"
                   :title="$t('editor.fields.list.add_item')"
                   @click="addToList" color="primary"
                   class="mx-auto" />
        </v-card-actions>
    </v-card>
</template>

<script setup>
import {computed} from "vue";
import draggable from "vuedraggable";
// https://www.npmjs.com/package/jsonpath
import jp from "jsonpath";
import {mandatory_props, resolveFieldPath} from "../../utils/editorConfigFieldHelpers";
import {getStoreByName} from "../../utils/storeHelpers";

const props = defineProps(mandatory_props);
const store = getStoreByName(props.storeName);

/**
 * The effective json_path of this field.
 * @see resolveFieldPath() - handles fields inside (repeatable) SubPanels
 */
const jsonPath = computed(() => resolveFieldPath(store, props.json_path));

// ----------------------------------------------------------------------------
// Computed Values
// ----------------------------------------------------------------------------
const value = computed({
    get() {
        return jp.value(store[props.jsonKey], jsonPath.value);
    },
    set(v) {
        try {
            jp.value(store[props.jsonKey], jsonPath.value, v);
        } catch (e) {
            console.log("Could not set value for json_path", jsonPath.value); // i18n-ignore (Konsole)
            console.log(e);
        }
    }
});


function addToList() {
    // If the list is new (i.e. an empty array) initialize a new one!
    if ( ! Array.isArray(value.value)) {
        value.value = [];
    }

    value.value.push({
        name: "",
        amount: "",
        link: "",
    });
}
function removeFromList(text) {
    let index = value.value.indexOf(text);
    value.value.splice(index, 1);
}


</script>

<style scoped>

</style>